<button
  pButton
  *ngIf="!items.length"
  [label]="
    !raceClasses.length
      ? appSettings.translate[appSettings.selectedLang]['classIsEmpty']
      : selectedClass.name
  "
  icon="pi pi-refresh"
  (click)="emitClass(this.selectedClass)"
></button>

<p-splitButton
  *ngIf="items.length"
  [label]="
    !raceClasses.length
      ? appSettings.translate[appSettings.selectedLang]['classIsEmpty']
      : selectedClass.name
  "
  icon="pi pi-refresh"
  (onClick)="emitClass(this.selectedClass)"
  [model]="items"
></p-splitButton>
